import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';


import { AngularFontAwesomeModule } from 'angular-font-awesome';


@NgModule({
  imports: [
    AngularFontAwesomeModule,
  ],
  declarations: [
   

  ],
  providers: [
    BrowserModule,


  ],
  exports: [
  ]
})
export class FwModule { }



// WEBPACK FOOTER //
// ./src/app/fw.module.ts